import { CommonModule } from '@angular/common';
import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  Type,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { SidenavDrawerService } from '../../services/sidenav-drawer.service';

@Component({
  selector: 'app-sidenav-drawer',
  templateUrl: './sidenav-drawer.component.html',
  styleUrls: ['./sidenav-drawer.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    MatSidenavModule,
  ],
})
export class SidenavDrawerComponent implements AfterViewInit {
  @ViewChild('drawer', { read: ElementRef }) drawerElement!: ElementRef;
  @ViewChild('drawer') drawer!: MatDrawer;
  @ViewChild('dynamicContainer', { read: ViewContainerRef })
  dynamicContainer!: ViewContainerRef;

  private currentComponentRefs: ComponentRef<any>[] = [];

  constructor(private sidenavDrawerService: SidenavDrawerService) { }

  ngAfterViewInit() {
    this.sidenavDrawerService.setDrawer(
      this.drawer,
      this.dynamicContainer,
      this.loadComponent.bind(this)
    );

    this.drawer.openedStart.subscribe(() => {
      document.body.classList.add('drawer-open');
    });

    this.drawer.closedStart.subscribe(() => {
      document.body.classList.remove('drawer-open');
      document.body.classList.remove('footer-drawer-open');
      this.clearContainer();
    });
  }

  onBackgroundClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('mat-drawer-inner-container')) {
      void this.sidenavDrawerService.close();
    }
  }

  clearContainer() {
    this.currentComponentRefs.forEach((ref) => ref.destroy());
    this.currentComponentRefs = [];
    this.dynamicContainer.clear();
  }

  loadComponent<T extends object>(component: Type<T>, data?: Partial<T>) {
    const componentRef = this.dynamicContainer.createComponent(component);
    if (data) {
      Object.assign(componentRef.instance, data);
    }
    this.currentComponentRefs.push(componentRef);
  }
}
